import { Injectable } from "@angular/core";
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationExtras, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PreviewDocViewerGuard  {
    constructor(private router: Router, private route: ActivatedRoute) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const sessionValueString = sessionStorage.getItem('useNewDocViewer');
        const useNewDocViewer = sessionValueString ? sessionValueString === 'true' : true;
        const queryParams = state.root.queryParams; // Get the existing query parameters
        const extras: NavigationExtras = {
            queryParams, // Pass the existing query parameters to the new URL
        };
        if (state.url.startsWith('/classic/doc-viewer')) {
            if (useNewDocViewer) {
                return this.router.createUrlTree(['/review/doc-viewer'], extras);
            }
        }
        if (state.url.startsWith('/review/doc-viewer')) {
            if (!useNewDocViewer)
                return this.router.createUrlTree(['/classic/doc-viewer'], extras);
        }

        return true; // Allow access to the requested route
    }
}